import React, { useEffect, useState, useCallback, useMemo } from "react";
import CustomButton from "../../components/Elements/Buttons/CustomButtons";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { useNavigate } from "react-router-dom";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { Tables } from "../../components/Elements/Tables/Tables";
import { ReactComponent as Back } from "../../assets/svgs/back-button.svg";
import { ReactComponent as DeleteIcon } from "../../assets/svgs/delete.svg";
import { API_URLS } from "../../api/apiUrls";
import { getApi, deleteApi } from "../../api/api_instance";
import CreateProjectTypeDialog from "./DialogBoxes/CreateReportType";
import EditReportType from "./DialogBoxes/EditReportType";
import SortData from "../../components/Elements/SortData/SortData";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";
import { ReactComponent as EditIcon } from "../../assets/svgs/greenEdit.svg";
const ReportType = () => {
  const navigate = useNavigate();
  const [projectTypes, setProjectTypes] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedProjectType, setSelectedProjectType] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    visible: false,
    type: "", // "success" | "error" | "warning"
    title: "",
    message: "",
  });

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Report  Type", key: "project_type" },
      { label: "Description", key: "description" },
      { label: "Action", key: "action" },
    ],
    []
  );

  const showPopup = (type, title, message, duration = 3000) => {
    setPopup({ visible: true, type, title, message });
    setTimeout(() => {
      setPopup({ visible: false, type: "", title: "", message: "" });
    }, duration);
  };


  const fetchReport = useCallback(
    async (id) => {
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_REPORT_TYPE(id),
        });

        if (response?.data) {
          setSelectedProjectType(response.data); // full details from API
          console.log(response.data);
          setOpenEditDialog(true);
        } else {
          showPopup("error", "Error", "No report data found");
        }
      } catch (error) {
        console.error("Error fetching report:", error);
        showPopup("error", "Error", error.message || "Failed to fetch report");
      }
    },
    []
  );


  const fetchProjectTypes = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const response = await getApi({
          apiUrl: API_URLS.ALL_REPORT_TYPES(page, pageSize, searchTerm),
        });

        if (response.data.data) {
          const projectData = response.data.data.map((item, index) => ({
            key: item._id,
            serial: (page - 1) * pageSize + (index + 1),
            project_type: item.name,
            description: item.description,
            action: (
              <div className="flex gap-4 items-center">
                <DeleteIcon
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => handleDeleteProjectType(item._id)}
                />
                <EditIcon onClick={() => fetchReport(item._id)} />
              </div>
            ),
          }));

          setProjectTypes(projectData);
          setTotal(response.data.metadata?.total || projectData.length);
        } else {
          setProjectTypes([]);
          setTotal(0);
        }
      } catch (error) {
        console.error("Error fetching project types:", error);
        setProjectTypes([]);
      } finally {
        setLoading(false);
      }
    },
    [searchTerm]
  );

  useEffect(() => {
    fetchProjectTypes(pageNo);
  }, [fetchProjectTypes, pageNo]);

  const handleDeleteProjectType = async (id) => {
    try {
      await deleteApi({ apiUrl: API_URLS.DELETE_REPORT_TYPE(id) });
      showPopup(
        "success",
        "Deleted Successfully",
        "Report Type deleted Successfully"
      );
      fetchProjectTypes(pageNo);
    } catch (error) {
      console.error("Error deleting project type:", error);
      showPopup(
        "error",
        "Error",
        error.message || "Failed to delete Project Type"
      );
    }
  };

  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
  };

  const sortedData = useMemo(() => {
    let data = [...projectTypes];
    if (sortBy && sortOrder) {
      data = SortData({ data, key: sortBy, order: sortOrder });
    }
    return data;
  }, [projectTypes, sortBy, sortOrder]);

  return (
    <div
      style={{  backgroundColor: "#fff" }}
      className="h-screen px-14"
    >
      <div className="flex justify-end text-xs font-light py-2 ">
        <p>Home</p>
        <span>/</span>
        <TextStyles color="gradient">Report  Types</TextStyles>
      </div>
      <div>
        <div className="flex items-center  gap-2 text-xl text-[#06513D] font-bold mb-2 px-2">
          {/* <Back onClick={() => navigate(-1)} className="cursor-pointer" /> */}
          <div>Reports Types</div>
        </div>

        <div
          style={{
            border: "1px solid #3BA2B959",
            borderRadius: "10px",
            paddingTop: "20px",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
          }}
        >
          <div className="flex justify-between px-3 mb-3">
            <div className="flex gap-4 pl-9">
              <SearchBar width="300px" onSearch={setSearchTerm} />
            </div>
            <div className="flex gap-4">
              <CustomButton
                buttonType="button"
                variant="ok"
                buttonText=" + Add New"
                onClick={() => setOpenCreateDialog(true)}
                className="text-base font-normal h-[50px] w-[160px]"
              />
            </div>
          </div>

          <Tables
            data={sortedData}
            headers={headers}
            pageSize={pageSize}
            current={pageNo}
            total={total}
            loading={loading}
            onChange={(page) => setPageNo(page)}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSort={handleSort}
          />
        </div>

        {openCreateDialog && (
          <CreateProjectTypeDialog
            onOpen={openCreateDialog}
            onClose={() => setOpenCreateDialog(false)}
            onSuccess={() => {
              fetchProjectTypes(pageNo);
              setOpenCreateDialog(false);
            }}
            // onSave={() => {
            //   showPopup(
            //     "success",
            //     "Created",
            //     "Report  Type Created Successfully"
            //   );
            // }}
            // onError={(message) => {
            //   showPopup(
            //     "error",
            //     "Failed",
            //     message || "Failed to create Project Type"
            //   );
            // }}
          />
        )}




















        {openEditDialog && selectedProjectType && (
          <>
            {/* {console.log("Selected Project Type:", selectedProjectType)}
            {console.log("Name:", selectedProjectType.report.name)}
            {console.log("Description:", selectedProjectType.description)}
            {console.log("ID:", selectedProjectType._id)} */}
            <EditReportType
              onOpen={openEditDialog}
              onClose={() => setOpenEditDialog(false)}
              projectData={selectedProjectType}
              onUpdate={() => {
                showPopup(
                  "success",
                  "Edited",
                  "Report Type Edited Successfully"
                );
                fetchProjectTypes(pageNo);
              }}
              onError={() => {
                showPopup("error", "Failed", "Failed in Updating Project Type");
              }}
            />
          </>
        )}
        {/* {openEditDialog && selectedProjectType && (
          <EditReportType
            onOpen={openEditDialog}
            onClose={() => setOpenEditDialog(false)}
            projectData={selectedProjectType}
            onUpdate={() => {
              showPopup(
                "success",
                "Edited",
                "Report  Type Edited Successfully"
              );
              fetchProjectTypes(pageNo);
            }}
            onError={() => {
              showPopup("error", "Failed", "Failed in Updating Project Type");
            }}
          />
        )} */}

        {/* {addNewProjectTypeSuccess && (
          <SuccessDailogBox
            onOpen={addNewProjectTypeSuccess}
            onClose={() => setAddNewProjectTypeSuccess(false)}
            popuptype="success"
            successMessage={"Project Type Created Successfully"}
          />
        )} */}

        {popup.visible && (
          <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
            <PopupCard
              type={popup.type}
              title={popup.title}
              message={popup.message}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportType;
